import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { apiCall } from "../../api/index";
import { showLoading } from "../slice/loadingSlice";

const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

export const otherInsufficientAdd = createAccountAsyncThunk(
  "post",
  "otherInsufficientAdd",
  "application/json",
  "valiantinfo_admin/InsufficientComments/add_othercheck_insufficient_comments/"
);

export const otherInsufficientReject = createAccountAsyncThunk(
  "post",
  "otherInsufficientReject",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_add_other_checks_insufficient_reject/"
);

export const otherInsufficientApprove = createAccountAsyncThunk(
  "post",
  "otherInsufficientApprove",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_add_other_checks_insufficient_approve/"
);

export const manualInsufficientReferenceData = createAccountAsyncThunk(
  "post",
  "manualReferenceCheckData",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_fetch_reference_checks_details/"
);

export const referenceInsufficientApprove = createAccountAsyncThunk(
  "post",
  "referenceInsufficientApprove",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_approve_reference_insufficient_checks/"
);

export const referenceInsufficientReject = createAccountAsyncThunk(
  "post",
  "referenceInsufficientReject",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_reject_reference_insufficient_checks/"
);

export const educationEmploymentCostAdd = createAccountAsyncThunk(
  "post",
  "educationEmploymentCostAdd",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_add_aditional_cost/"
);

export const listAdditionalCost = createAccountAsyncThunk(
  "post",
  "listAdditionalCost",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_list_additional_cost_candidates/"
);

export const listAdditionalExpenseDetails = createAccountAsyncThunk(
  "post",
  "listAdditionalExpenseDetails",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_list_additional_expense_details/"
);

export const updateOtherExpenses = createAccountAsyncThunk(
  "post",
  "updateOtherExpenses",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_update_other_expenses/"
);

export const recallAdditionalCost = createAccountAsyncThunk(
  "post",
  "recallAdditionalCost",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_recall_additional_cost/"
);

export const cancelAdditionalCost = createAccountAsyncThunk(
  "post",
  "cancelAdditionalCost",
  "application/json",
  "valiantinfo_admin/InsufficientComments/admin_cancel_additional_cost/"
);

export const financeRecallDecision = createAccountAsyncThunk(
  "post",
  "financeRecallDecision",
  "application/json",
  "valiantinfo_admin/InsufficientComments/finance_recall_decision_additional_cost/"
);

// /InsufficientComments/admin_approver_for_finance_verification/

export const approverForFinanceVerification = createAccountAsyncThunk(
  "post",
  "listAdditionalCost",
  "multipart/form-data",
  "valiantinfo_admin/InsufficientComments/admin_approver_for_finance_verification/"
);

export const addCommentsPendingChecks = createAccountAsyncThunk(
  "post",
  "addCommentsPendingChecks",
  "application/json",
  "valiantinfo_admin/InsufficientComments/add_comments_pending_checks/"
);

export const deleteCommentsPendingChecks = createAccountAsyncThunk(
  "post",
  "deleteCommentsPendingChecks",
  "application/json",
  "valiantinfo_admin/InsufficientComments/delete_pending_check_details/"
);